import { useModal } from '@/hooks'
import React from 'react'
import style from './styles/contest_work.module.scss'

interface IProps {
  image: string
  number: string | number
  author: string
  date: string
}

const ContestWorkCard = ({
  image,
  number,
  author,
  date
}: IProps): React.ReactElement => {
  const { openModal } = useModal()

  const handleOpenModal = (): void => {
    openModal('contestWork', { image, number, author, date })
  }

  return (
    <button
      type='button'
      onClick={handleOpenModal}
      className={style.work__button}
    >
      <img
        src={image}
        width='343px'
        height='343px'
        alt='Фото работы'
        className={style.work__image}
      />
      <div className={style.work_content}>
        <span className={style.work__number}>№{number}</span>
        {author !== ''
          ? (
            <span className={style.work__author}>{author}</span>
            )
          : null}
        <span className={style.work__date}>{date}</span>
      </div>
    </button>
  )
}

export default ContestWorkCard
